import { Box, ToggleButtonGroup, Typography } from "@mui/material";
import {
  last14Days,
  last30Days,
  last3rdMonth,
  lastMonthEnd,
  lastMonthStart,
  today,
  todayEnd,
  weekFromToday,
} from "constants/dates";
import { useGetTableData } from "hooks/useGetTableData";
import { useTranslation } from "react-i18next";
import SelectionInvoices from "./SelectionInvoices";
import SelectionOrders from "./SelectionOrders";

const QuickSelection = ({
  setChosenPeriod,
  setActiveDate,
  setPresetPeriod,
  presetPeriod,
}) => {
  const { t } = useTranslation();
  const { isInvoices } = useGetTableData();

  const setToday = () => {
    setChosenPeriod([today, todayEnd]);
    setActiveDate(today);
  };

  const setOneWeek = () => {
    setChosenPeriod([today, weekFromToday]);
    setActiveDate(today);
  };

  const setLastMonth = () => {
    setChosenPeriod([lastMonthStart, lastMonthEnd]);
    setActiveDate(lastMonthStart);
  };

  const setLast14Days = () => {
    setChosenPeriod([last14Days, todayEnd]);
    setActiveDate(last14Days);
  };

  const setLast3Months = () => {
    setChosenPeriod([last3rdMonth, lastMonthEnd]);
    setActiveDate(last3rdMonth);
  };

  const setLast30Days = () => {
    setChosenPeriod([last30Days, todayEnd]);
    setActiveDate(last30Days);
  };

  const handlePresetDate = (_, presetPeriod) => setPresetPeriod(presetPeriod);

  return (
    <Box marginLeft="16px">
      <Box
        sx={{
          paddingLeft: "16px",
          marginBottom: "16px",
          height: "44px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography color="#99afb7">
          {t("datePicker.quickSelection")}
        </Typography>
      </Box>
      <ToggleButtonGroup
        value={presetPeriod}
        exclusive
        onChange={handlePresetDate}
        aria-label="preset period"
        sx={{ flexDirection: "column" }}
      >
        {isInvoices ? (
          <SelectionInvoices
            setLast14Days={setLast14Days}
            setLast30Days={setLast30Days}
            setLastMonth={setLastMonth}
            setLast3Months={setLast3Months}
          />
        ) : (
          <SelectionOrders
            setLastMonth={setLastMonth}
            setOneWeek={setOneWeek}
            setToday={setToday}
          />
        )}
      </ToggleButtonGroup>
    </Box>
  );
};

export default QuickSelection;
